import { styled } from '@mui/material/styles'
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import { Colors, Typographies } from 'src/components/theme'

export const DarkTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow={props.arrow !== undefined ? props.arrow : true} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: Colors.textDark,
    '&:before': {
      boxShadow: `1px 1px 1px 0px rgb(0 0 0 / 10%), 0px 1px 1px 0px rgb(0 0 0 / 5%)`,
    },
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: Colors.textDark,
    color: Colors.textWhite,
    fontSize: Typographies.text1m.fontSize,
    boxShadow: Colors.BOX_SHADOW,
    fontFamily: Typographies.text1m.fontFamily,
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    marginBottom: '5px !important',
  },
}))
